// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-widget__block .text-content p:last-child{margin-bottom:0}.content-widget__block-button{margin-top:40px}", ""]);
// Exports
module.exports = exports;
